import React from "react";
import AddUserModal from "../../common/addUserModal";
import { createBanker, updateBanker } from "../../../services/banker.service";
import { bankerMessages } from "../../../constants/message.constant";

type BankerData = {
  id?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  street: string;
  city: string;
  state: string;
  zipcode: string;
};

type AddBankerModalProps = {
  open: boolean;
  handleClose: (action?: string) => void;
  businessId: string;
  editMode?: boolean;
  bankerData?: BankerData;
};

const AddBankerModal = ({
  open,
  handleClose,
  businessId,
  editMode = false,
  bankerData,
}: AddBankerModalProps) => {
  return (
    <AddUserModal
      open={open}
      handleClose={handleClose}
      businessId={businessId}
      editMode={editMode}
      userData={bankerData}
      title="Banker"
      createUser={createBanker}
      updateUser={updateBanker}
      successMessages={{
        add: bankerMessages.addBanker,
        edit: bankerMessages.editBanker,
      }}
    />
  );
};

export default AddBankerModal;
